import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

/**
 * In the top right corner of a card
 * Sets the cardFloat topology
 */
const CardFloat: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      {children}
    </Box>
  );
};

export default CardFloat;
